import sanityClient from '@sanity/client'

export default sanityClient({
  projectId:process.env.REACT_APP_PROJECT_ID,
  dataset:"production",
  apiVersion: '2021-11-19',
  useCdn: true
})